import { ShippingAddressInterface } from "./ShippingAddressInterface";
import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";

export const ShippingCard = ({ shippingAddress }: { shippingAddress: ShippingAddressInterface }) => {
  const { language } = useAuth();
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{dictionary["shipping-address"][language]}</h2>
      
      <div className="space-y-1 text-gray-700">
        <p className="font-medium">
          {shippingAddress.name}
          {shippingAddress.last_name && ` ${shippingAddress.last_name}`}
        </p>
        <p>{shippingAddress.address}</p>
        {shippingAddress.address_detail && <p>{shippingAddress.address_detail}</p>}
        {(shippingAddress.city || shippingAddress.department) && (
          <p>
            {shippingAddress.city}
            {shippingAddress.city && shippingAddress.department && " - "}
            {shippingAddress.department}
          </p>
        )}
        {shippingAddress.neighborhood && <p>{shippingAddress.neighborhood}</p>}
      </div>
    </div>
  );
};
